/**
 * @description 有效追踪率
 *
 * @props {Boolean} explain 是否显示说明
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <span class="rate">有效追踪率</span>
      <span class="target">目标：超过 95%</span>
    </div>
    <div class="main">
      <div class="detalis1">
        <div class="item-cell date">
          <span class="day">时间范围：{{ validTracking.duration }}天</span>
          <span>{{ validTracking.timeFrameStart | convertToDate}} - {{ validTracking.timeFrameEnd | convertToDate }}</span>
        </div>
        <div class="item-cell rate" :class="{abnormal: !validTracking.completeTarget}">{{ validTracking.rate }}</div>
        <div class="item-cell">
          <span>有效追踪编码的货件数：</span>
          <span>{{ validTracking.count }}</span>
        </div>
        <div class="item-cell">
          <span>货件总数：</span>
          <span>{{ validTracking.totalCount | defaultShow}}</span>
        </div>
      </div>
      <div class="detalis2">
        <div>
          <span>Category</span>
          <span>有效追踪率</span>
        </div>
        <div>
          <span>默认</span>
          <span>{{ validTracking.rate }}({{ validTracking.count }}/ {{ validTracking.totalCount | defaultShow}})</span>
        </div>
      </div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertToDate } from "@/utils/date.util"

export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    validTracking: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      message: [
        "有效追踪率 (VTR) 是指在给定的 30 天时间段内具有有效追踪编码的所有货件数占总货件数的百分比。 VTR仅适用于卖家自配送订单。",
        "亚马逊的买家根据追踪编码了解订单配送状态和预计收货时间。",
        "亚马逊的政策规定，卖家需维持大于95%的 VTR。 如果某商品分类的 VTR 低于95%，亚马逊可能会限制您在此分类下销售非亚马逊物流 (FBA) 商品的权限。",
      ],
    };
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  },
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  line-height: 1;
  padding-bottom: 40px;
  .title {
    padding: 20px 0;
    .rate {
      padding: 0 15px 0 20px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
    .target {
      color: #666;
      font-size: 12px;
    }
  }
  .main {
    display: flex;
    .detalis1 {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      .item-cell {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-left: 40px;
        padding-bottom: 22px;
        &.rate {
          font-size: 24px;
          color: #333;
          font-weight: 600;
          padding: 10px 0 22px 40px;
        }
        &.date {
          width: 250px;
          font-size: 12px;
          padding-left: 0;
          .day {
            padding-right: 15px;
          }
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
    .detalis2 {
      width: 30%;
      border-left: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      color: #333;
      font-size: 14px;
      font-weight: 600;
      >div {
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-around
      }
    }
    .message {
      border-left: 1px solid #ccc;
      width: 40%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding-right: 26px;
      padding-left: 30px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
  }
}
</style>